import { render, staticRenderFns } from "./IKFiltroFuncionario.vue?vue&type=template&id=20eeefa2&"
import script from "./IKFiltroFuncionario.vue?vue&type=script&lang=js&"
export * from "./IKFiltroFuncionario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports